import React from 'react';
import {
  resolveGraphNodeRenderableNode,
  useWorkflowRenderCatalog,
} from '../../workflow-render-catalog';
import { WorkflowNodeShell } from './workflow-node-shell';
import type { WorkflowNodeHandles, WorkflowNodeViewData } from './types';
import { WorkflowRunStatusBadge } from '../../workflow-run-status';

export type WorkflowNodeProps = {
  node: WorkflowNodeViewData;
  handles?: WorkflowNodeHandles;
  className?: string;
  /** Optional run-status overlay badge; omitted on the editor canvas. */
  status?: string | null;
};

/**
 * Renders a workflow graph node using the strategy registered for `node.type`.
 */
export const WorkflowNode: React.FC<WorkflowNodeProps> = ({
  node,
  handles,
  className,
  status,
}) => {
  const catalog = useWorkflowRenderCatalog();
  const strategy = resolveGraphNodeRenderableNode(catalog, node.type).view;
  const title = strategy.getTitle(node);
  const description = strategy.getDescription?.(node);
  const icon = strategy.renderIcon?.(node);
  const body = strategy.renderBody(node);

  return (
    <WorkflowNodeShell
      title={title}
      description={description}
      icon={icon}
      accent={strategy.accent}
      badge={strategy.badge}
      handles={handles}
      className={className}
    >
      {body}
      {status && (
        <div className="mt-2">
          <WorkflowRunStatusBadge status={status} />
        </div>
      )}
    </WorkflowNodeShell>
  );
};
